import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getSampleLessonsService = async (
  userToken: string,
) => {
  return axiosV4.get(`/user/sample-exams/lessons`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
